import { useStaticQuery, graphql } from 'gatsby';
import { convertPageArrayToTree, flattenPageTree } from '../utils/tree';

const cache = {};

export const getPages = () => {
  if (cache.pages) {
    // console.log('returning from cache');
    return cache.pages;
  }
  const { siteConfig, allContentfulPage } = useStaticQuery(
    graphql`
      query {
        siteConfig: contentfulConfig(title: {eq: "Site config"}) {
          rootPage {
            contentful_id
          }
        }
        allContentfulPage(filter: {node_locale: {eq: "en-US"}}) {
          nodes {
            contentful_id
            slug
            title
            childPages {
              contentful_id
            }
          }
        }
      }
    `,
  );

  if (allContentfulPage) {
    const rootPageId = siteConfig.rootPage.contentful_id;
    const rawPages = allContentfulPage.nodes
      .map(({ contentful_id: id, childPages, ...rest }) => (
        {
          id,
          children: childPages ? childPages
            .map(({ contentful_id: childId }) => ({ id: childId })) : null,
          ...rest,
        }
      ));
    // console.log(pages);
    const pageTree = convertPageArrayToTree(rawPages, rootPageId);
    const flattenedPages = flattenPageTree(pageTree);

    const pages = {
      raw: rawPages,
      tree: pageTree,
      flattened: flattenedPages,
    };

    // console.log(flattenedPages);
    cache.pages = pages;
    return pages;
  }
  return null;
};

export const getContentfulPageWithPath = (id) => {
  const pages = getPages();
  return pages.flattened[id];
};

// export const getContentfulPageTree = () => getPages().tree;
